const Logo = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Max's Stock Machine logo"
  >
    {/* Candlestick 1 — bearish (red) */}
    <line
      x1="7"
      y1="4"
      x2="7"
      y2="8"
      stroke="#f87171"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="4.5" y="8" width="5" height="10" rx="1" fill="#f87171" />
    <line
      x1="7"
      y1="18"
      x2="7"
      y2="22"
      stroke="#f87171"
      strokeWidth="1.5"
      strokeLinecap="round"
    />

    {/* Candlestick 2 — bullish (green) */}
    <line
      x1="16"
      y1="6"
      x2="16"
      y2="11"
      stroke="#34d399"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="13.5" y="11" width="5" height="13" rx="1" fill="#34d399" />
    <line
      x1="16"
      y1="24"
      x2="16"
      y2="28"
      stroke="#34d399"
      strokeWidth="1.5"
      strokeLinecap="round"
    />

    {/* Candlestick 3 — bullish (green, shorter) */}
    <line
      x1="25"
      y1="8"
      x2="25"
      y2="12"
      stroke="#34d399"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <rect x="22.5" y="12" width="5" height="8" rx="1" fill="#34d399" />
    <line
      x1="25"
      y1="20"
      x2="25"
      y2="24"
      stroke="#34d399"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Logo;
